import React, { Fragment } from 'react';

import styles from './TagsUsage.css';

const getImagePath = image => require(`@assets/images/tags/${image}.png`);

const TagsUsage = () => (
  <Fragment>
    <section>
      <article className="flex-row">
        <div className="left">
          <h1 className="h1 page-title">
            Tags are relevant keywords associated with or assigned to a piece of information.
          </h1>
        </div>
        <div className="right copy-content">
          <p>Tags are used for items that need to be labeled, categorized, or organized using keywords that describe them. They can be presented individually as a selector or in a tag cloud. Tags can also be used as a method of filtering data, to show only items within that particular category.</p>
        </div>
      </article>
    </section>

    <section className="bg-grey with-padding flex-grow-1">
      <article className="flex-justify-end flex-row last">
        <div className="right copy-content">
          <h2 className="h2 page-subtitle">Tag Cloud</h2>
          <div className={styles.tagsImg}>
            <img src={getImagePath('tags-cloud')} alt="tags cloud" />
          </div>

          <h2 className="h2 page-subtitle">Draggable Tags</h2>
          <div className={styles.tagsImg}>
            <img src={getImagePath('draggable-tags')} alt="tags cloud" />
          </div>
        </div>
      </article>
    </section>
  </Fragment>
);

export default TagsUsage;


// WEBPACK FOOTER //
// ./src/containers/elements/Tags/TagsUsage/TagsUsage.js